import styled from "styled-components";

export const CMLadyDesktop = styled.img`
    position: absolute;
    bottom: 18.9%;
    left: 24%;
    width: 41%;
    height: auto;
`;

export const CMPaperDesktop = styled.img`
    position: absolute;
    bottom: 44%;
    height: auto;
    left: 12%;
    width: 15%;
`;